<template>
<div>
  <div :class="settingsClass" @click="toggleSettings"></div>
  <div v-if="showSettings">
    
    <div class="settingsTextBox" :style="'opacity:'+textOpacity+';width:'+settingsWidth+'px;'">
       <div v-if="true" class="settingsClose" @click="settingsOut">x</div>

      Settings<br><br>

      Mute <p-check  name="check1"  value="custom" v-model="mute"></p-check>
     
     
      <div  @click="toggleAudio" >Volume - <span class="settingBtn">{{ volumeVals[volumeIndex].label}}</span></div>
      <div  @click="toggleFXAudio" >Sound FX Volume - <span class="settingBtn">{{ fxVolumeVals[fxVolumeIndex].label}}</span></div>
       <div v-if="canTest">
       Tester Mode <p-check  name="check1"  value="custom" v-model="tester"></p-check><br>
       </div>
      <div v-if="isTester">
       Exhibit Model <p-check  name="check1"  value="custom" v-model="exModel"></p-check><br>

       Edit Map <p-check  name="check1"  value="custom" v-model="mapEdit"></p-check><br>
       Debug Mode <p-check  name="check1"  value="custom" v-model="doDebug"></p-check><br>

       </div>
     </div>
  </div>
  </div>
</template>

<script>
import gsap from "gsap";
import screen from "@/mixins/screen"
import TypeOn from '@/components/TypeOn'

export default {
  mixins:[ screen],
  components: {
   TypeOn
  },
  data() {
    return {
      tester:true,
      canTest:false,
      mute:false,
      doDebug:false,
      exModel:true,
      mapEdit:false,
      displayVolume:1,
      volumeIndex:2,
      fxVolumeIndex:2,
      volumeVals:[{label:"LOW",val:0.1},{label:"MED",val:.3},{label:"HIGH",val:1}],
      fxVolumeVals:[{label:"OFF",val:0},{label:"LOW",val:0.1},{label:"MED",val:.3},{label:"HIGH",val:.5}],
       showSettings:false,
        textOpacity:1,
       
      
    };
  },
  mounted(){
   
  },
  computed:{
    isTester(){
				return this.$store.getters.getIsTester
			},
     settingsClass(){
      return this.$store.getters.getSettingsClass
    },
    volume(){
      return this.$store.getters.getVolume
    },
    settingsWidth(){
      if(this.showAI){
        return 800
      }
      return 500
    },
    settingsInnerMax(){
      return Math.max(this.windowWidth,this.windowHeight)*2
    },
    settingsText(){
      if(this.settings)
      {
        return this.settings.text
      }
    },
   
  },
  methods:{
   
     toggleAudio(){
        this.volumeIndex=(this.volumeIndex+1)%this.volumeVals.length
       
       this.$store.commit("setVolume",this.volumeVals[this.volumeIndex].val);
     },
     toggleFXAudio(){
        this.fxVolumeIndex=(this.fxVolumeIndex+1)%this.fxVolumeVals.length
       
       this.$store.commit("setFXVolume",this.fxVolumeVals[this.fxVolumeIndex].val);
     },
     toggleSettings(){
       if(this.showSettings){
         this.settingsOut()
       }else{
         this.settingsIn()
       }
     },
    settingsIn(){
      this.showSettings=true
      gsap.to(this,.3,{textOpacity:1})
    },
    settingsOut(){
      gsap.to(this,.3,{textOpacity:0,onComplete:this.settingsDone})  
    },
    settingsDone(){
       this.showSettings=false
    }
  },
  watch:{
    tester(val){
      this.$store.commit("setIsTester",val)
      
    },
    isTester(val){
      if(val){
        this.canTest=true
      }
    },
    doDebug(val){
      this.$store.commit("setDebug",val)
    },
   exModel(val){
      this.$store.commit("setExhibitModel",val)
   },
   mapEdit(val){
      this.$store.commit("setMapEdit",val)
   },
    mute(val){
      if(val){
       this.$store.commit("setVolume",0); 
       this.$store.commit("setFXVolume",0); 
      } else{
        this.$store.commit("setVolume",this.volumeVals[this.volumeIndex].val);
        this.$store.commit("setFXVolume",this.fxVolumeVals[this.fxVolumeIndex].val);
      }
    }
    
  }
};
</script>

<style>
  .transission{
    z-index: 3;
    position:absolute;
    left:calc(50% - 1050px);
    top:calc(50% - 1050px);
    width:100px;
    height:100px;
    border-radius:50%;
    border:#000 solid 1000px;
  }
  .settingBtn{
    cursor:pointer;
    background-color:#fff3;
  }
  .settingBtn:hover{
    background-color:#fff6;
  }
  .settingsTextBox{
    z-index: 4;
    font-size:16px;
    line-height: 28px;
    width:800px;
    min-height:180px;
    border-radius:5px;
    text-align:left;
    position:absolute;
    left:0px;
    right:0px;
    bottom:25%;
    color:#fff;
    background-color:#000e;
    padding:20px;
    margin:auto;
  
    
  }
  .settingsText{
    background-color:#000000b4;
    padding:10px;
    width:680px;
    min-height:280px;

  }
  
  .settingsIcon{
    position:absolute;
    opacity:0.5;
    top:100px;
    right:20px;
    width:40px;
    height:40px;
    background-size:40px 80px;
    background-image:url('../../assets/images/icons/settings.png');
  }
  .settingsIcon.exhibitPlan{
    top:100px;
    background-position:0px -40px;
    opacity:0.3
  }
  .settingsIcon.exhibit{
    top:30px;
    background-position:0px -40px;
    opacity:0.3
  }
  .settingsIcon.dive{
    top:5%;
  }
  .settingsIcon.ship{
    top:5%;
    filter: brightness(1) saturate(0);
  }
  .settingsIcon.intro{
    top:5%;
    filter: brightness(1) saturate(0);
  }
  .settingsIcon:hover{
     opacity:0.7;
  }
  .settingsClose{
    color:#fff;
    position: absolute;
    top: 0px;
    right: 0px;
    cursor: pointer;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    text-align: center;
  }
  .settingsClose:hover{
    background-color: #3e3e3e;
  }
</style>